import React, { useState, useEffect } from "react";
import { SUBUSER } from "../../../Service/service";
import { patchData } from "../../../Service/ApiMethod";
// import Swal from "sweetalert2";

const UpdateSubUser = (props) => {
  // console.log(props?.editType, "edit type");
  // console.log(props.id)
  const initialValues = {
    subuser_id: "",
    username: "",
    first_name: "",
    last_name: "",
    email: "",
    phone: "",
    password: "",
    confirm_password: "",
  };
  const [selectedData, setSelectedData] = useState(initialValues);

  // const handleChange = (event) => {
  //   setSelectedData(event.target.value);
  console.log('initialvalue', initialValues)
  console.log(selectedData, "selected");

  console.log(selectedData?.subuser_id, "iddddd");

  // };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setSelectedData({
      ...selectedData,
      [name]: value,
    });
  };
  //  console.log(handleInpu)
  // useEffect(() => {
  //   if (!props.editType) return;
  //   setSelectedData(props.editType);
  //   const selectedArray = props.editType;
  //   console.log(selectedArray, "selected");
  //   const filterArray = selectedArray.filter(
  //     (item) => item.id == props.subuser_id
  //   );
  //   setSelectedData(filterArray[0]?.username);
  // }, [props.editType]);

  useEffect(() => {
    setSelectedData({
      subuser_id: props?.data?.id,
      username: props?.data?.username,
      first_name: props?.data.first_name,
      last_name: props?.data.last_name,
      email: props?.data?.email,
      phone: props?.data?.phone,
      password: props?.data?.password,
      confirm_password: props?.data?.confirm_password,
    });
  }, []);


  const obj = selectedData
  const validpassword = (pass) => {
    return pass.match(
      // /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/
      /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/
    );
  }
  async function postHandle() {

    if (selectedData?.confirm_password == undefined) {
      alert("confirm Password Required")
    } else if (selectedData?.password == undefined) {
      alert("Password Required")
    } else if (selectedData?.username == "") {
      alert("Username Required")
    } else if (selectedData?.first_name == "") {
      alert("First name required")
    } else if (selectedData?.last_name == "") {
      alert("Last name required")
    } else if (selectedData?.confirm_password !== selectedData?.password) {
      alert("Password doesnot match")
    }else if(!validpassword(selectedData?.password)){
      alert("A password should be alphanumeric.First letter of the password should be capital.Password must contain a special character (@, $, !, &, etc).Password length must be greater than 8 characters.");
      // setLoaderstart(false)
    }
    else {

      patchData(obj, SUBUSER)
        .then((response) => response.json())
        .then((data) => {
          alert(data?.message)
          props.closePopup();
          console.log(data, "dattaaaaaaaaaaa")
          setTimeout(() => {
            props?.setPopup(true)
          }, 1000)
        }
        );
    }
  }

  const handupdate = () => {
    postHandle();


  };


const [showPassword, setShowPassword] = useState(false)
const [showcomPassword, setShowcomPassword] = useState(false)
  return (
    <div className="blur-screen flex-center">
      {console.log(props.data, "confirm selected data")}
      <div className="UpdateSubUser position-relative">
        <img
          src="./grey-cross.png"
          className="dismiss-popup"
          alt=""
          onClick={props.closePopup}
        />
        <h4 className="heading text-center mb-3">Edit</h4>
        <input
          type="text"
          name="username"
          value={selectedData?.username}
          onChange={handleInputChange}
          placeholder="User Name"
          className=" custom-input border-2 w-100 mb-3"
        />
        <br />
        <input
          type="text"
          name="first_name"
          value={selectedData.first_name}
          onChange={handleInputChange}
          placeholder="First Name"
          className=" custom-input border-2 w-100 mb-3"
        />{" "}
        <br />
        <input
          type="text"
          name="last_name"
          value={selectedData.last_name}
          onChange={handleInputChange}
          placeholder="Last Name"
          className=" custom-input border-2 w-100 mb-3"
        />{" "}
        <br />
        <input
          type="text"
          name="email"
          value={selectedData.email}
          onChange={handleInputChange}
          placeholder="Email Id"
          className=" custom-input border-2 w-100 mb-3"
        />{" "}
        <br />
        <input
          type="text"
          name="number"
          value={selectedData?.phone}
          onChange={handleInputChange}
          placeholder="Phone No."
          className=" custom-input border-2 w-100 mb-3"
        />{" "}
        <br />
        <div className="custom-input border-2 w-100">
        <input
          type={showPassword == true ?"text":'password'}
          name="password"
          value={selectedData?.password}
          onChange={handleInputChange}
          placeholder="Password."
          className="w-150"
          style={{width:'90%'}}
        /> <span onClick={() => setShowPassword(!showPassword)}  >
        {showPassword ? <i className="fa fa-eye" aria-hidden="true" /> : <i class="fa fa-eye-slash" aria-hidden="true" />}
      </span>
      </div>
        {" "}
        <br />
        <div className="custom-input border-2 w-100">
        <input
          type={showcomPassword == true ?"text":'password'}
          name="confirm_password"
          value={selectedData?.confirm_password}
          onChange={handleInputChange}
          placeholder="Confirm Password"
          className="w-150"
          style={{width:'90%'}}
        />
         <span onClick={() => setShowcomPassword(!showcomPassword)} style={{marginLeft:5}} >
        {showcomPassword ? <i className="fa fa-eye" aria-hidden="true" /> : <i class="fa fa-eye-slash" aria-hidden="true" />}
      </span>
      </div>
        {" "}
        {/* <input type="file" className=" custom-input w-100"  /> <br /> */}
        <div className=" flex-center justify-content-between">
          <button
            className="btn admin-outline-dark mt-3 "
            onClick={props.closePopup}
          >
            Cancel
          </button>
          <button className="btn admin-btn mt-3 " onClick={() => handupdate()}>
            Save
          </button>
        </div>
      </div>
    </div>
  );
};

export default UpdateSubUser;
